module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/keyboard-arrow-down-6ae65bbf387f3e43977e8059cee7f120.svg";